<template lang="pug">
div
  v-dialog(width="500", v-model="dialogSave")
    v-card
      v-card-title(v-if="dialogTxt === 'save'") Saved
      v-card-text(v-if="dialogTxt === 'save'") Your form has been saved and you will receive an email with a link to your saved form.
      v-card-title(v-if="dialogTxt === 'submit'") Submitted
      v-card-text(v-if="dialogTxt === 'submit'") Your form has been submitted and you will receive an email with a link to your saved form.
      v-card-actions
        v-spacer
        v-btn(color="primary", text, @click="dialogAck()") OK
</template>
<script>
import store from "../store";
import { mapState, mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
export default {
  store,
  methods: {
    ...mapActions(["setDialogSave"]),
    dialogAck() {
      this.$store.commit("setDialogSave", false);
    },
  },
  actions: {
    setDialogSave(state, value) {
      state.dialogSave = value;
    },
  },
  computed: {
    ...mapState({
      data: (state) => state.data,
    }),
    ...mapFields(["dialogSave", "dialogTxt"]),
  },
};
</script>